import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const viewSelectedIcon = createIconDefinition(
  'viewSelectedIcon',
  `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
<path d="M13.75 2.5H11.25V4.16667H13.75V2.5Z"/>
<path d="M15.8333 2.5V4.16667H17.5C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"/>
<path d="M17.5 15.8333H15.8333V17.5C16.7538 17.5 17.5 16.7538 17.5 15.8333Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 6.94499H2.5V13.0561H17.5V6.94499ZM4.16667 11.3894V8.61165H15.8333V11.3894H4.16667Z"/>
<path d="M9.16667 2.5V4.16667L6.66667 4.16667V2.5H9.16667Z"/>
<path d="M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5V4.16667L2.5 4.16667Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.16667 17.5C3.24619 17.5 2.5 16.7538 2.5 15.8333H4.16667V17.5ZM6.66667 17.5H9.16667V15.8333H6.66667V17.5Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 15.8333H12.9167V17.5H11.25V15.8333Z"/>
<path d="M12.9167 17.5V15.8333H13.75V17.5H12.9167Z"/>
<path d="M2.5 4.16667L4.16667 4.16667V5H2.5V4.16667Z"/>
<path d="M2.5 15H4.16667V15.8333H2.5V15Z"/>
<path d="M15.8333 15H17.5V15.8333H15.8333V15Z"/>
<path d="M17.5 4.16667H15.8333V5H17.5V4.16667Z"/>
<path d="M4.16667 2.5V4.16667V5H4.58333V2.5H4.16667Z"/>
<path d="M15.8333 4.16667V2.5H15.4167V5H15.8333V4.16667Z"/>
<path d="M4.16667 15.8333V17.5H4.58333V15H4.16667V15.8333Z"/>
<path d="M15.8333 17.5V15.8333V15H15.4167V17.5H15.8333Z"/>
</svg>`,
);
